import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getPurchaseOrderLookup } from "../../api/purchaseOrderApi";

export default function PurchaseOrderAccountSelect({ propertyId, label, value, onChange, disabled, required }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setOptions([]); setLoading(true); setError(false);
    const load = async () => {
      try {
        let page = 1;
        let rows = [];
        while (true) {
          const { data } = await getPurchaseOrderLookup(propertyId, "accounts", { page, page_size: 100 });
          if (cancelled) return;
          rows = [...rows, ...data.results];
          if (rows.length >= data.total || !data.results.length) break;
          page += 1;
        }
        setOptions(rows);
      } catch (_) { if (!cancelled) setError(true); }
      finally { if (!cancelled) setLoading(false); }
    };
    load();
    return () => { cancelled = true; };
  }, [propertyId, retry]);
  return <FormControl required={required} disabled={disabled}>
    <FormLabel id="po-account-label">{label}</FormLabel>
    <Box sx={{ maxHeight: 240, overflowY: "auto", border: 1, borderColor: "divider", borderRadius: 1, px: 2, mt: 1 }}>
      {loading ? <CircularProgress size={24} aria-label="Loading accounts" sx={{ my: 2 }} /> : error ? <Alert severity="error">Could not load accounts. <Button startIcon={<RefreshIcon />} disabled={disabled} onClick={() => setRetry((current) => current + 1)}>Retry</Button></Alert> : <>
        <RadioGroup aria-labelledby="po-account-label" name="po-account" value={value?.id ?? ""} onChange={(_, id) => onChange(options.find((option) => String(option.id) === id))}>
          {options.map((option) => <FormControlLabel key={option.id} value={option.id} control={<Radio required={required} />} label={option.label} />)}
        </RadioGroup>
        {!options.length && <Typography sx={{ py: 2 }}>No active expense accounts available.</Typography>}
      </>}
    </Box>
  </FormControl>;
}
